// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sm-service-table {
    overflow: auto;
}
.sm-empty-state {
    padding: 32px;
    text-align: center;
    color: #888;
    font-size: 14px;
}
.sm-service-link {
    color: var(--link-color, #0078d4);
    text-decoration: none;
    cursor: pointer;
}
.sm-service-link:hover { text-decoration: underline; }
.sm-image-cell {
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
    color: #666;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.sm-badge {
    display: inline-block;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 3px;
    font-weight: 600;
    vertical-align: middle;
    margin-left: 6px;
}
.sm-badge-sandbox {
    background: #e6f4ea;
    color: #1e7e34;
}
`, "",{"version":3,"sources":["webpack://./src/service-monitor.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,eAAe;AACnB;AACA,yBAAyB,0BAA0B,EAAE;AACrD;IACI,gEAAgE;IAChE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":["#sm-service-table {\n    overflow: auto;\n}\n.sm-empty-state {\n    padding: 32px;\n    text-align: center;\n    color: #888;\n    font-size: 14px;\n}\n.sm-service-link {\n    color: var(--link-color, #0078d4);\n    text-decoration: none;\n    cursor: pointer;\n}\n.sm-service-link:hover { text-decoration: underline; }\n.sm-image-cell {\n    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Consolas', monospace;\n    font-size: 12px;\n    color: #666;\n    max-width: 300px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.sm-badge {\n    display: inline-block;\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 3px;\n    font-weight: 600;\n    vertical-align: middle;\n    margin-left: 6px;\n}\n.sm-badge-sandbox {\n    background: #e6f4ea;\n    color: #1e7e34;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
